/**
 * AppSidebar component - Main sidebar navigation
 * Based on shadcn/ui dashboard-01 block design
 */

import { Link, useLocation } from 'react-router-dom'
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'
import { Logo } from '@/components/common/Logo'
import {
  IconLayoutDashboard,
  IconPackage,
  IconHistory,
  IconChartBar,
  IconTarget,
  IconSettings,
} from '@tabler/icons-react'
import { cn } from '@/lib/utils'

interface NavItem {
  title: string
  url: string
  icon: React.ComponentType<any>
}

const navItems: NavItem[] = [
  { title: 'Dashboard', url: '/', icon: IconLayoutDashboard },
  { title: 'Tài sản', url: '/assets', icon: IconPackage },
  { title: 'Lịch sử Giá', url: '/prices', icon: IconHistory },
  { title: 'Báo cáo', url: '/reports', icon: IconChartBar },
  { title: 'Kỳ vọng', url: '/expectations', icon: IconTarget },
  { title: 'Cài đặt', url: '/settings', icon: IconSettings },
]

export function AppSidebar() {
  const location = useLocation()
  const currentPath = location.pathname

  return (
    <Sidebar>
      <SidebarContent>
        <SidebarGroup>
          <div className="px-3 sm:px-2 py-3 sm:py-4">
            <Logo showIcon={true} showText={true} />
          </div>
        </SidebarGroup>
        <SidebarGroup>
          <SidebarGroupLabel className="px-3 sm:px-2 text-xs sm:text-xs">Điều hướng</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {navItems.map((item) => {
                const isActive =
                  currentPath === item.url ||
                  (item.url !== '/' && currentPath.startsWith(item.url))
                const Icon = item.icon

                return (
                  <SidebarMenuItem key={item.url}>
                    <SidebarMenuButton
                      asChild
                      isActive={isActive}
                      className={cn(
                        'min-h-[48px] sm:min-h-[44px] px-3 sm:px-2 py-3 sm:py-2 text-base sm:text-sm',
                        isActive && 'bg-primary text-primary-foreground'
                      )}
                    >
                      <Link to={item.url} className="flex items-center gap-3 sm:gap-2">
                        <Icon className="h-5 w-5 sm:h-4 sm:w-4 flex-shrink-0" stroke={1.5} />
                        <span className="font-medium">{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                )
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  )
}

